import script from "./MenuTemplate.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuTemplate.vue?vue&type=script&setup=true&lang=js"

import "./MenuTemplate.vue?vue&type=style&index=0&id=e6210756&lang=scss&scoped=true"

import exportComponent from "/usr/local/tomcat-jenkins/data/workspace/3d-editor-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e6210756"]])

export default __exports__